import React from 'react';
import { Modal } from 'react-bootstrap';
import { Container } from './styles';
import { BiddingInfoTypes } from '../../../store/modules/bidding_store/types';
import BiddingInfoList from '../../organisms/bidding_info_list';

interface BiddingInfoDropdownProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  typeName: string;
  bidding_info: BiddingInfoTypes[];
  // eslint-disable-next-line react/require-default-props
  className?: string;
  // eslint-disable-next-line react/require-default-props
  backdropClassName?: string;
  // eslint-disable-next-line react/require-default-props
  hideBiddingNumber?: boolean;
  // eslint-disable-next-line react/require-default-props
  initiallyOpen?: boolean;
  // eslint-disable-next-line react/require-default-props
  trackEvents?: boolean;
}
const BiddingInfoModal: React.FC<BiddingInfoDropdownProps> = ({
  showModal,
  setShowModal,
  typeName,
  bidding_info,
  className,
  backdropClassName,
  hideBiddingNumber = false,
  initiallyOpen,
  trackEvents,
}) => {
  return (
    <Modal
      show={showModal}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      className={className}
      backdropClassName={backdropClassName}
      onHide={() => setShowModal(false)}
    >
      <Container>
        <div className="bg-modal position-relative">
          <div className="row py-2 m-0 row-custom">
            <div className="col-md-4">{typeName}</div>
            <div className="col-md text-right mr-2">
              {hideBiddingNumber ? null : `Nº ConLicitação: ${bidding_info?.[0]?.bidding_id}`}
            </div>
            <div className="col-md-1">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>

          <div className="row p-2 m-1">
            <div className="col-md-12 py-2">
              <BiddingInfoList
                bidding_info={bidding_info}
                initiallyOpen={initiallyOpen}
                trackEvents={trackEvents}
              />
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};
export default BiddingInfoModal;
